import BasicModelFactory from "../BasicModelFactory";
import DataChoice, {IDataChoices} from "./DataChoice";
import DataModel from "./DataModel";
import {IAnyObject} from "../../../common/SimpleInterface";


export default class DataFactory extends BasicModelFactory
{
    choices: IDataChoices = {};

    birth(id: string): DataModel
    {
        return new DataModel(id);
    }

    birthDataChoice(object:IAnyObject): DataChoice
    {
        return new DataChoice(object);
    }


    resetPopulated(conditional?:(model:DataModel) => boolean): void
    {
        for(let modelID in this.conditionModels){
            const model = this.conditionModels[modelID] as DataModel;
            if(!conditional || conditional(model)){
                model.resetPopulated();
            }
        }
    }

    resetData(): void
    {
        for(let modelID in this.conditionModels){
            const model = this.conditionModels[modelID] as DataModel;
            model.resetData();
        }
    }
}